import { isSourceReady } from './sources/sourceStatus';

export const NO_CHANGES_REASON =
  'No changes since your last update. Add, remove or retry a source, or add a Program, to update.';

const idOf = (value) => String(value?._id ?? value ?? '');

const sameIds = (left, right) => {
  const a = new Set(left.map(idOf));
  const b = new Set(right.map(idOf));
  return a.size === b.size && [...a].every((id) => b.has(id));
};

/**
 * Whether an Update would read anything the last successful build did not.
 * Unknown means changed: a profile built before its inputs were recorded, or
 * one whose last build did not finish, must stay updatable.
 */
export const hasChangesSinceBuild = (profile, sources = [], programs = []) => {
  if (profile?.status !== 'ready') return true;
  const { builtFromSources, builtFromPrograms } = profile;
  if (!Array.isArray(builtFromSources) || !Array.isArray(builtFromPrograms)) return true;
  const readySources = sources.filter(isSourceReady);
  return !sameIds(readySources, builtFromSources) || !sameIds(programs, builtFromPrograms);
};
